 
import { Component, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core';
import {  CandidateApi, CandidateProfile, DocumentType, DocumentInstructions, CandidateAdditionDocumentRequest } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
 
import { LoaderService } from 'src/app/core/loader.service';
import { nullSafe } from 'src/app/utils';


@Component({
  selector: 'eos-candidate-addition-doc-request',
  templateUrl: './candidate-addition-doc-request.component.html',
  styleUrls: ['./candidate-addition-doc-request.component.css']
})
export class CandidateAdditionDocRequestComponent implements OnInit {

  
  @Input() profile: CandidateProfile;
 
  @Input() public submit: (requestList) => void;
 
  documentList: DocumentType[];
  distinctDocTypes: DocumentType[];
  fileDetails: CandidateAdditionDocumentRequest;
 // AddedDocs: DocumentType[] = []
  docName: string;
  docInstruction: string;
  docsForDocTypes: DocumentType[];
  documentInstructions: DocumentInstructions[] = [];
  requestList: CandidateAdditionDocumentRequest[]=[];
  AddedDocs: DocumentType[] = []
  requestedDocu: CandidateAdditionDocumentRequest[] = []
  isDocumentAdded = false;
  
  constructor(public modal: NgbActiveModal, 
    private candidateApi: CandidateApi,
    private common: CommonService,
    private loader : LoaderService,
    private toast: ToastService,  ) {
    this.fileDetails = new CandidateAdditionDocumentRequest();
    this.fileDetails.docTypeId = null;
    this.fileDetails.docNameId = null;
    this.fileDetails.isMandatory = true;
    this.fileDetails.comment="";
  }

  ngOnInit() {
    this.getDocumentTypes();
    //this.getDocumentInstructions();
    this.getAlreadyRequestedlist();
  }

  get getdistinctDocTypes(): DocumentType[] {
    this.distinctDocTypes = [];
    if (this.documentList && this.documentList.length > 0) {
      this.distinctDocTypes = this.documentList.filter(
        (docType, i, arr) => arr.findIndex(t => t.docTypeId === docType.docTypeId) === i);
    }
    return this.distinctDocTypes;
  }
  getDocumentInstructions() {
    this.common.GetDocumentInstructions()
      .subscribe(resp => {
        this.documentInstructions = resp;
      });
  }

  getAlreadyRequestedlist(){
    this.candidateApi.getRequestedDocuments( this.profile.id)
    .subscribe(resp => {
      this.requestedDocu = resp;
     

    });
} 

  setCMDocTypes() {
    this.fileDetails.docNameId = null;
    this.docInstruction = null;
    this.docsForDocTypes = this.documentList ? this.documentList.filter(t => t.docTypeId == this.fileDetails.docTypeId) : [];
    if (this.docsForDocTypes.length === 1) {
      this.fileDetails.docNameId = this.docsForDocTypes[0].docNameId;
       this.setCMDocInstruction();
    }
  }

  
   

  setCMDocInstruction() {
    this.docInstruction = null;
    this.docInstruction = nullSafe(() => this.documentInstructions.filter(t => t.docNameId === this.fileDetails.docNameId)[0].documentInstruction, '');
  }


  get documentTypes() {
    if (!this.documentList || !this.documentList.length) { return [] }
    return this.documentList.filter(doc => doc.docTypeId === +this.fileDetails.docTypeId);
  }

  getDocumentTypes() {
  
    this.candidateApi.getRequiredDocuments('PTC',false,this.profile)
      .subscribe(resp => {
        this.documentList = resp;
 
      });
  }

  deleteDocs(item: DocumentType) {
    this.AddedDocs.forEach((value, index) => {
      if (value.docNameId === item.docNameId)
       this.AddedDocs.splice(index, 1); 
    });
    this.requestList.forEach((value, index) => {
      if (value.docNameId === item.docNameId)
       this.requestList.splice(index, 1); 
    });

  }
  addDocs(f: NgForm) {
    this.isDocumentAdded = false;
    if (f.invalid) {
      return;
    } 
    if (!(this.AddedDocs.filter(res  =>res.docNameId == this.fileDetails.docNameId).length > 0) && this.fileDetails.docTypeId != null
    ) {
      var res = this.documentList.find(t => t.docNameId == this.fileDetails.docNameId);
     
      this.AddedDocs.push(res);
      this.fileDetails.docTypeDisplayText=res.docTypeDisplayText;
      this.requestList.push(this.fileDetails);
      this.isDocumentAdded = true;
      this.clearSelect(); //setTimeout(()=>{ this.clearSelect() }, 3000)
    
    }else{

      this.toast.warning('Document already requested');
      return;
    }

  }
  
  clearSelect()
   {   this.fileDetails = new CandidateAdditionDocumentRequest();
      this.fileDetails.docTypeId = null;
      this.fileDetails.docNameId = null;
     // this.fileDetails.docTypeDisplayText='';
       this.fileDetails.comment="";
      this.fileDetails.isMandatory = true;}

  requestDocuments() {
    this.modal.close();
    this.submit(this.requestList);
  
}
 



}
